import {
  ActionType as ActionTypeQuantity
} from "../product-quantity/const.js";

export const TABLET_MEDIA_QUERY = `(max-width: 700px)`;

export const defaultCartProductItemModelData = {
  isLayoutChanged: false,
  sessionElementId: null,
  price: null,
  quantity: null,
  totalPrice: null,
  isSummaryRendered: false,
  isRemoved: false,
  isRemoving: false,
  initComparisonTrigger: false,
  initAddToCartTrigger: false,
  initOneClickBuyTrigger: false,
};

export const ActionType = Object.assign(
    {},
    ActionTypeQuantity,
    {
      ADJUST_LAYOUT: `ADJUST_LAYOUT`,
      RESET_VIEW: `RESET_VIEW`,
      INIT: `INIT`,
      SHOW_SUMMARY: `SHOW_SUMMARY`,
      HIDE_SUMMARY: `HIDE_SUMMARY`,
      REMOVING: `REMOVING`,
      REMOVE: `REMOVE`,
      REMOVE_ERROR: `REMOVE_ERROR`,
      CLEAR: `CLEAR`,
      REMOVE_FROM_LIST: `REMOVE_FROM_LIST`
    }
);

export const REMOVE_ITEM_ANIMATION_DURATION = 200;

export const CONNECTOR_URL = `/assets/components/ecommerce/connector.php`;

export const RequestAction = {
  REMOVE_PRODUCT: `remove_product`
};

